import { LocalEnrichmentProvider } from 'crono-fe-common/components/EnrichmentLoaderSkeleton/types';
import { PostExternalEnrichmentProviderPayload } from 'crono-fe-common/types/externalEnrichmentProviders';

export type EnrichDataTypePayload = Partial<
  Pick<
    PostExternalEnrichmentProviderPayload,
    'enrichCompany' | 'enrichLinkedin' | 'enrichPhone' | 'enrichEmail'
  >
>;

export function buildEnrichDataTypePayload(
  formState: {
    enrichCompany: boolean;
    enrichLinkedin: boolean;
    enrichPhone: boolean;
    enrichEmail: boolean;
  },
  provider: LocalEnrichmentProvider,
  providerDataProvided: string[],
): EnrichDataTypePayload {
  const payload: EnrichDataTypePayload = {};

  if (
    formState.enrichCompany !==
      provider?.dataProvided.includes('company linkedIn url') &&
    providerDataProvided.includes('company linkedIn url')
  ) {
    payload.enrichCompany = formState.enrichCompany;
  }

  if (
    formState.enrichLinkedin !==
      provider?.dataProvided.includes('contact linkedIn url') &&
    providerDataProvided.includes('contact linkedIn url')
  ) {
    payload.enrichLinkedin = formState.enrichLinkedin;
  }

  if (
    formState.enrichPhone !== provider?.dataProvided.includes('phone') &&
    providerDataProvided.includes('phone')
  ) {
    payload.enrichPhone = formState.enrichPhone;
  }

  if (
    formState.enrichEmail !== provider?.dataProvided.includes('email') &&
    providerDataProvided.includes('email')
  ) {
    payload.enrichEmail = formState.enrichEmail;
  }

  return payload;
}

// ─── ZoomInfo OAuth ───────────────────────────────────────────────────────────
export const ZOOMINFO_REDIRECT_URI = `${process.env.VITE_APP_FE_URL}/connect/zoominfo/callback`;
export const ZOOMINFO_STATE_KEY = 'zoominfo_oauth_state';
